// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Xi7Fk{display:flex;flex-direction:column;width:100%}.GqXoN{display:flex;align-items:center;gap:12px;width:100%;background:transparent;border:none;padding:0;text-align:left;color:inherit;font:inherit;cursor:pointer}.GqXoN.sNGkp{cursor:default}.FqYga{flex-shrink:0;display:flex;align-items:center}.FyJhY{flex:1}.zZmgX{flex-shrink:0;display:flex;align-items:center}.ZSJ1Q{margin-top:12px;width:100%}.x5NKZ{margin-top:12px;margin-left:36px;width:calc(100% - 36px)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Xi7Fk`,
	"header": `GqXoN`,
	"notExpandable": `sNGkp`,
	"icon": `FqYga`,
	"headline": `FyJhY`,
	"chevron": `zZmgX`,
	"preview": `ZSJ1Q`,
	"previewsRow": `x5NKZ`
};
export default ___CSS_LOADER_EXPORT___;
